import {EntryDesc} from 'generated/JavaTOmodifications'
import {GroupBase} from 'react-select'

export function createEntryDescSelectDatasource(entryDescs: EntryDesc[]): GroupBase<EntryDesc>[] {
	let dsGrouped: {
		options: EntryDesc[]
		label?: string
	}[] = []
	let prevCategoryLabel: string
	let i = -1
	entryDescs.forEach(e => {
		if (prevCategoryLabel === undefined || prevCategoryLabel !== e.categoryLabel) {
			prevCategoryLabel = e.categoryLabel
			i++
		}
		dsGrouped[i] = dsGrouped[i] || {label: e.categoryLabel, options: []}
		dsGrouped[i].options = dsGrouped[i].options.concat(e)
	})
	return dsGrouped
}